exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.installment-confirmation {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.installment-confirmation > label {\r\n    font-size: 1.15em;\r\n}\r\n", ""]);

// exports
